import React from "react";
import Chart from "react-apexcharts";
import { COLOR_SIN_DEUDA, colorTramo } from "./constants";
import { formatCurrency, formatNumber } from "./utils";

export default function GraficoAntiguedad(props) {
    const total = props.total || 0;
    const moneda = props.moneda || "PEN";
    // Sin deuda (el servicio devuelve [] o todos los tramos en 0) ApexCharts
    // no dibuja ningun tramo: se pinta uno gris de relleno para que la dona
    // se vea igual, pero en 0.
    const sinDeuda = total <= 0;
    const datos = sinDeuda ? [{ nombre: "Sin deuda", total: 0, porcentaje: 0 }] : props.datos || [];

    const options = {
        chart: { type: "donut" },
        labels: datos.map((item) => item.nombre),
        colors: sinDeuda ? [COLOR_SIN_DEUDA] : datos.map((item) => colorTramo(item.orden)),
        dataLabels: { enabled: false },
        stroke: { width: 2 },
        legend: {
            position: "right",
            verticalAlign: "middle",
            fontSize: "13px",
            itemMargin: { vertical: 7 },
            // Ocultar el tramo de relleno dejaria la dona en blanco.
            onItemClick: { toggleDataSeries: !sinDeuda },
            formatter: (nombre, opts) => {
                const item = datos[opts.seriesIndex] || { total: 0, porcentaje: 0 };
                // ApexCharts inserta este resultado como innerHTML, por eso
                // el <br/> corta la linea antes del monto.
                return `${nombre}<br/><span style="color:#64748b">${formatCurrency(item.total, moneda)} (${formatNumber(item.porcentaje, 0)}%)</span>`;
            },
        },
        plotOptions: {
            pie: {
                donut: {
                    size: "62%",
                    labels: {
                        show: true,
                        value: {
                            fontSize: "18px",
                            fontWeight: 700,
                            formatter: (val) => formatCurrency(val, moneda, 0),
                        },
                        total: {
                            show: true,
                            label: "Total",
                            fontSize: "13px",
                            formatter: () => formatCurrency(total, moneda, 0),
                        },
                    },
                },
            },
        },
        // Los tooltips de dona no usan tooltip.y.title (es para charts de
        // ejes); el contenido se arma a mano con monto y %.
        tooltip: {
            custom: ({ seriesIndex, w }) => {
                const item = datos[seriesIndex] || { nombre: "", total: 0, porcentaje: 0 };
                const color = w.config.colors[seriesIndex % w.config.colors.length];
                return `
                    <div style="padding:8px 12px;">
                        <span style="color:${color};margin-right:6px;">●</span>
                        <strong>${item.nombre}</strong>: ${formatCurrency(item.total, moneda)} (${formatNumber(item.porcentaje)}%)
                    </div>
                `;
            },
        },
        // En pantallas angostas la leyenda a la derecha aprieta la dona; ahi
        // se pasa a leyenda inferior en vez de forzar scroll horizontal.
        responsive: [
            {
                breakpoint: 576,
                options: {
                    legend: {
                        position: "bottom",
                        itemMargin: { horizontal: 8, vertical: 4 },
                    },
                },
            },
        ],
    };

    // react-apexcharts compara las options con JSON.stringify, que ignora las
    // funciones: si solo cambian montos o moneda (formatters de leyenda y
    // total), no re-renderiza. La key obliga a remontar la dona.
    const claveDatos = datos.map((item) => `${item.nombre}:${item.total}`).join("|");

    return (
        <Chart
            key={`${moneda}-${claveDatos}`}
            options={options}
            series={sinDeuda ? [1] : datos.map((item) => item.total)}
            type="donut"
            width="100%"
            height={300}
        />
    );
}
